import { REST_METHOD, REST_URL } from './../constants';
import { requestAsset, requestShipping } from './api';

export interface GetPickUpDepotParams {
  country: string;
  request_type: string;
  user_uid?: string;
  employee_type?: string;
  asset?: string;
}

const ShippingServices = {
  getValidAddress: async (params: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.SHIPPING}${REST_URL.ADDRESS_VALIDATION}`,
        method: `${REST_METHOD.POST}`,
        data: { ...params },
      };
      const response = await requestShipping(requestParams);
      return response.data;
    } catch (error) {
      console.error('Error', JSON.stringify(error));
      return [];
    }
  },

  getJsonConfigAddressFields: async () => {
    try {
      const requestParams = {
        url: `${REST_URL.SHIPPING}${REST_URL.ADDRESS_FIELDS}`,
        method: `${REST_METHOD.GET}`
      };
      const response = await requestShipping(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getPickUpDepot: async (params: GetPickUpDepotParams) => {
    try {
      const requestParams = {
        url: `${REST_URL.ASSET}${REST_URL.GET_PICKUP_DEPOT}`,
        method: `${REST_METHOD.GET}`,
        queryParams: params,        
      };
      const response = await requestAsset(requestParams);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getPickUpLocationUserLogin: async (params: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.ASSET}${REST_URL.GET_PICKUP_LOCATION_USER_LOGIN}`,
        method: `${REST_METHOD.GET}`,
        queryParams: {...params},        
      };
      const response = await requestAsset(requestParams);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getPickUpLocation: async (country: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.ASSET}${REST_URL.GET_PICKUP_LOCATIONS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: {country: country},        
      };
      const response = await requestAsset(requestParams);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  sortList: (list: any[], property: string) => {
    if (!Array.isArray(list) || list.length === 0) return [];

    return list.sort((a, b) => {
			const nameA = !!a[property] && a[property].toUpperCase();
			const nameB = !!b[property] && b[property].toUpperCase();
			return nameA < nameB ? -1 : (nameA > nameB ? 1 : 0);
		});
  },
};

export default ShippingServices;
